import { render, staticRenderFns } from "./dashboard_brand_manager.vue?vue&type=template&id=12e3a2f8"
import script from "./dashboard_brand_manager.vue?vue&type=script&lang=js"
export * from "./dashboard_brand_manager.vue?vue&type=script&lang=js"
import style0 from "./dashboard_brand_manager.vue?vue&type=style&index=0&id=12e3a2f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports